(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');

exports.Z = _default;

/***/ }),

/***/ 87794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(1150);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _meta_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53183);



var PageMetaHead = function(param) {
    var page_meta = param.page_meta, useExactTitle = param.useExactTitle;
    if (!page_meta) return null;
    var title = page_meta.title ? "".concat(_meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC, " - ").concat(page_meta.title) : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    if (useExactTitle) {
        title = page_meta.title ? page_meta.title : _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_NAME */ .iC;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            page_meta.keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: _meta_config__WEBPACK_IMPORTED_MODULE_2__/* .APP_META_KEYWORDS */ .FK
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: title
            }, "og:site_name"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }, "twitter:title"),
            page_meta.description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: page_meta.description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: page_meta.description
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: page_meta.description
                    }, "twitter:description")
                ]
            }),
            page_meta.thumbnail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: page_meta.thumbnail
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: page_meta.thumbnail
                    }, "og:image:secure_url"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: page_meta.thumbnail
                    }, "twitter:image")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaHead);


/***/ }),

/***/ 1150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/logic/config/meta/PageMetaHead.tsx
var PageMetaHead = __webpack_require__(51199);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/EmailOutlined.js
var EmailOutlined = __webpack_require__(6968);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(93789);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/logic/constants/links.ts
var links = __webpack_require__(84667);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/contact/ContactHero.tsx





var ContactHero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: 8,
        style: {
            backgroundColor: "#0074FF",
            background: "linear-gradient(93.37deg, #0074FF 0%, #005CCA 46%, #004699 100%)",
            color: "#fff"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "page__content",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                alignItems: "center",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 6,
                        xl: 6,
                        item: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                position: "relative",
                                width: "100%",
                                maxWidth: "500px",
                                maxHeight: "350px",
                                height: "auto",
                                aspectRatio: "5 / 3.5"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                objectFit: "cover",
                                objectPosition: "top center",
                                layout: "fill",
                                src: "/assets/images/sign-up/RegisterPhoto.png",
                                alt: "",
                                style: {
                                    borderRadius: "20px"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 6,
                        xl: 6,
                        item: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                my: 2,
                                color: "#fff",
                                fontWeight: 600,
                                fontSize: {
                                    xs: 40,
                                    lg: 64
                                },
                                lineHeight: 0.9,
                                component: "h1",
                                children: "Get in touch"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                my: 3,
                                color: "#fff",
                                fontWeight: 400,
                                fontSize: {
                                    xs: 13,
                                    lg: 18
                                },
                                lineHeight: 1.6,
                                maxWidth: "600px",
                                sx: {
                                    opacity: 0.9
                                },
                                children: "Book a free personalized demo on our website, or contact our sales team. We'll walk you through the platform, assess your needs, and outline next steps."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: "min(100%, 500px)",
                                    height: "1px",
                                    backgroundColor: "#fff",
                                    opacity: 0.2
                                },
                                mb: 3
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "#fff",
                                fontWeight: 800,
                                fontSize: {
                                    xs: 13,
                                    lg: 18
                                },
                                mb: 1,
                                children: "Ronald Richards"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailOutlined/* default */.Z, {
                                        sx: {
                                            fontSize: {
                                                xs: 20,
                                                lg: 26
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: "#fff",
                                        fontWeight: 600,
                                        fontSize: {
                                            xs: 13,
                                            lg: 18
                                        },
                                        lineHeight: 1,
                                        sx: {
                                            textDecoration: "underline"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:".concat(links/* EMAIL */.xK),
                                            style: {
                                                all: "unset",
                                                cursor: "pointer"
                                            },
                                            children: links/* EMAIL */.xK
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var contact_ContactHero = (ContactHero);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CancelOutlined.js
var CancelOutlined = __webpack_require__(68047);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircleOutline.js
var CheckCircleOutline = __webpack_require__(18037);
// EXTERNAL MODULE: ./src/ui/components/smart/landing/contact/ContactForm.tsx
var ContactForm = __webpack_require__(52067);
// EXTERNAL MODULE: ./src/ui/components/smart/landing/contact/ContactUsPopup.tsx
var ContactUsPopup = __webpack_require__(76655);
// EXTERNAL MODULE: ./src/ui/components/smart/landing/contact/StatusPopup.tsx
var StatusPopup = __webpack_require__(81163);
;// CONCATENATED MODULE: ./src/ui/components/smart/landing/contact/ContactSection.tsx











var ContactSection = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState("idle"), 2), status = ref[0], setStatus = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusPopup/* default */.Z, {
                isOpen: status === "success",
                onClose: function() {
                    return setStatus("idle");
                },
                color: "success",
                Icon: CheckCircleOutline/* default */.Z,
                description: "Your message was successfully sent"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusPopup/* default */.Z, {
                isOpen: status === "error",
                onClose: function() {
                    return setStatus("idle");
                },
                color: "error",
                Icon: CancelOutlined/* default */.Z,
                description: "Something went wrong. Try again later"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                py: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "page__content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            textAlign: "center",
                            fontSize: {
                                xs: 26,
                                lg: 44
                            },
                            fontWeight: 600,
                            color: "#070A0D",
                            lineHeight: 1,
                            component: "h2",
                            children: [
                                "Got a question for us?",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: "#005FCC"
                                    },
                                    children: "Get in touch"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "#3C434A",
                            lineHeight: 1.5,
                            fontSize: {
                                xs: 12,
                                lg: 16
                            },
                            fontWeight: 400,
                            textAlign: "center",
                            my: 2,
                            children: "Use the form below to tell us a bit about yourself, and we will get back to you soon."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            mt: 6,
                            sx: {
                                boxShadow: "0px 0px 40px 0px #0017721A",
                                borderRadius: "20px",
                                maxWidth: "800px",
                                marginInline: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    sx: {
                                        gap: {
                                            xs: 1,
                                            lg: 2
                                        }
                                    },
                                    px: 3,
                                    py: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailOutlined/* default */.Z, {
                                                    sx: {
                                                        fontSize: {
                                                            xs: 20,
                                                            lg: 26
                                                        }
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    color: "#000",
                                                    fontWeight: 600,
                                                    fontSize: {
                                                        xs: 13,
                                                        lg: 18
                                                    },
                                                    lineHeight: 1,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "mailto:".concat(links/* EMAIL */.xK),
                                                        style: {
                                                            all: "unset",
                                                            cursor: "pointer"
                                                        },
                                                        children: links/* EMAIL */.xK
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: "flex",
                                            alignItems: "center",
                                            sx: {
                                                gap: {
                                                    xs: 1,
                                                    lg: 2
                                                }
                                            },
                                            children: ContactUsPopup/* social_media.map */.q.map(function(item) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: item.link,
                                                    target: "_blank",
                                                    rel: "noreferrer noopener",
                                                    style: {
                                                        display: "flex",
                                                        color: "#005FCC"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                        sx: {
                                                            fontSize: {
                                                                xs: 20,
                                                                lg: 26
                                                            }
                                                        }
                                                    })
                                                }, item.link);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm/* default */.Z, {
                                    onSuccess: function() {
                                        return setStatus("success");
                                    },
                                    onError: function() {
                                        return setStatus("error");
                                    }
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var contact_ContactSection = (ContactSection);

// EXTERNAL MODULE: ./src/ui/components/smart/landing/layout/LandingLayout.tsx + 2 modules
var LandingLayout = __webpack_require__(28140);
;// CONCATENATED MODULE: ./src/pages/contact-us.tsx






var ContactPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaHead/* default */.Z, {
                page_meta: {
                    title: "Contact Us | Get in Touch with the eProcurement Team",
                    description: "Have questions about our procurement platform? Contact eProcurement for support, partnership inquiries, or to request a product demo"
                },
                useExactTitle: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_ContactHero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_ContactSection, {})
                ]
            })
        ]
    });
};
ContactPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingLayout/* default */.Z, {
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var contact_us = (ContactPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8140,9774,2888,179], function() { return __webpack_exec__(87794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);